import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-popup',
  templateUrl: './video-popup.component.html',
  styleUrls: ['./video-popup.component.css'],
  standalone: false
})
export class VideoPopupComponent implements AfterViewInit {
  @ViewChild('player') player!: ElementRef<HTMLVideoElement>;
  safeSrc: SafeResourceUrl;

  /** Shared dialog sizing so the player opens large enough for comfortable viewing. */
  static openConfig(data: { videoPath: string; poster?: string }): MatDialogConfig {
    return {
      data,
      width: '96vw',
      maxWidth: '1200px',
      panelClass: 'video-popup-panel',
      autoFocus: false
    };
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { videoPath: string; poster?: string },
    private ref: MatDialogRef<VideoPopupComponent>,
    sanitizer: DomSanitizer
  ) {
    this.safeSrc = sanitizer.bypassSecurityTrustResourceUrl(data.videoPath);
  }

  ngAfterViewInit(): void {
    const v = this.player.nativeElement;
    v.muted = true;
    v.play().catch(() => {
      /* Autoplay blocked - user can press play */
    });
  }

  onClose(): void {
    const v = this.player?.nativeElement;
    try {
      v?.pause();
      v?.removeAttribute('src');
      v?.load();
    } catch {}
    this.ref.close();
  }

  onVideoError(e: Event): void {
    console.error('Video error', e);
  }
}
